import { Menu } from "@/types/menu";

const menuData: Menu[] = [
  {
    id: 1,
    code: "services",
    path: "/#services",
    newTab: false,
  },
  {
    id: 2,
    code: "process",
    path: "/#process",
    newTab: false,
  },
  {
    id: 3,
    code: "stack",
    path: "/#stack",
    newTab: false,
  },
  {
    id: 4,
    code: "careers",
    path: "/#careers",
    newTab: false,
  },
];

export default menuData;
